var map = {
	"./Mancala-ai-logo.png": "ad4f",
	"./SortingVisualizer.png": "b519",
	"./blue.png": "9c88",
	"./die-detector-api.png": "8ca1",
	"./healz.png": "c174",
	"./itch.png": "ce85",
	"./kaggle.png": "a80d",
	"./portfolio.png": "9b5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc1f";